<template>
  <div id="app">
    <audio muted src="static/bg.mp3" autoplay="true" id="bgm"  loop="true"></audio>
    <audio src="" id="buttonAudio"></audio>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{


  },
  mounted(){

  }


}
</script>

<style>
embed{
      height: 0;
    width: 0;
    margin: 0;
    padding: 0;
    position: absolute;
}
body {
  font-family: PingFangSC-Light,'helvetica neue','hiragino sans gb',tahoma,'microsoft yahei ui','microsoft yahei',simsun;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}
:focus {
    outline: none;
}
  p{padding: 0;margin: 0;}
	header{height:60px;background:#004976;position: relative;}
	header img{position: absolute;left: 0;top: 0;height: 60px;}
	header .subtitle {margin-left: 240px;color: #fff;font-size: 16px;}
	header .subtitle span{line-height: 60px;display: inline-block;padding-left: 20px;}
	.content{width: 100%;height: 100%;  display: flex;}
	.content iframe,.content .seclect{float: left;}
	.content iframe {width: 60%;height: inherit;}
	.content .seclect{width: 40%;overflow: scroll;padding-bottom: 60px;}
  .content .seclect h2{padding: 5% 5% 15% 10%;font-size: 40px;color: #535b68;margin: 0;}
  .content .seclect .brand{padding:0 10%;font-size: 16px;color: #535b68;}
  .content .seclect .brand .text p:first-child{color: #15eebd;padding-top: 10px;}
  .content .seclect .brand .text p:last-child{padding-top: 5%;font-size:32px;color: #9b9ea7}
  .content .seclect .brand .text p:last-child span{display: block;font-size: 14px;padding-top: 10px;}

  footer{position:fixed;bottom: 0;left: 0;height: 60px;background: #f7f8fa;width:100%;}
  footer div:first-child{display: flex;color:#004976;font-size: 16px;line-height: 60px;}
  footer div div{width: 33.3%}
  footer div .prev{padding-left: 4%;}
  footer div .prev a{color:#004976;text-decoration: none;}
  footer div .step {padding-left: 25%;}
  footer div .step span{width: 45px;height: 45px;border-radius: 50%;background: #007dbb;display: inline-block;color: #fff;line-height: 45px;text-align: center;}
  footer div .continue {text-align: right;padding-right: 4%}
  footer div .continue button{color: #004976;    border:1px solid #226188;border-radius:45px;width:35%;padding: 3% 6%;
  font-size: 16px;cursor: pointer; }
  footer div .continue button:hover{background: #004976;color: #fff;}

</style>



// WEBPACK FOOTER //
// src/App.vue